import { render } from "./TeachDateView.vue?vue&type=template&id=53387d2e&scoped=true"
import script from "./TeachDateView.vue?vue&type=script&lang=js"
export * from "./TeachDateView.vue?vue&type=script&lang=js"

import "./TeachDateView.vue?vue&type=style&index=0&id=53387d2e&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53387d2e"]])

export default __exports__